import React, { useContext, useEffect, useState } from "react";
import { AuthContext } from "./Auth";
import { db } from "./base";
import { NavLink } from "react-router-dom";
import "./nav.scss";
import firebase from "firebase/app";
import {
  faFilePdf,
  faHome,
  faClipboardList,
  faSignOutAlt,
  faFileCode,
  faUser,
  faNetworkWired,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const Nav = () => {
  const { currentUser } = useContext(AuthContext);
  const [user, setUser] = useState("");
  const [userName, setUserName] = useState("");

  useEffect(() => {
    if (currentUser !== null) {
      db.collection("users")
        .doc(currentUser.uid)
        .get()
        .then((doc) => {
          setUser(doc.data().role);
          setUserName(doc.data().username);
        });
    }
  }, []);

  const [showMenuNav, setShowMenunav] = useState("show-nav-inactive");
  const [showFondNav, setShowFondNav] = useState("show-fond-inactive");

  function handleClick() {
    if (showMenuNav === "show-nav-inactive") {
      setShowMenunav("show-nav-active");
      setShowFondNav("show-fond-active");
    } else {
      setShowMenunav("show-nav-inactive");
      setShowFondNav("show-fond-inactive");
    }
  }

  const handleLogOut = () => {
    firebase
      .auth()
      .signOut()
      .then(function () {})
      .catch(function (error) {
        console.log("Erreur LogOut: ", error);
      });
  };

  return (
    <>
      <div
        id="fond-close-nav"
        className={showFondNav}
        onClick={handleClick}
      ></div>
      <div id="nav" className={showMenuNav}>
        <div className="user_email">
          <FontAwesomeIcon icon={faUser} />
          <span>{userName}</span>
        </div>
        <NavLink to="/" activeClassName="noactive">
          <FontAwesomeIcon icon={faHome} />
          <span>Accueil</span>
        </NavLink>
        {user === "admin" && (
          <>
            {/* <NavLink to="/signup" activeClassName="active">
              <FontAwesomeIcon icon={faFileCode} />
              <span>Création de compte</span>
            </NavLink> */}
            <NavLink to="/fichiers-pdf-site-internet" activeClassName="active">
              <FontAwesomeIcon icon={faNetworkWired} />
              <span>Admin PDF Site Internet</span>
            </NavLink>
            <NavLink to="/fichiers-produits-clients" activeClassName="active">
              <FontAwesomeIcon icon={faFileCode} />
              <span>Admin Produits Clients</span>
            </NavLink>
            <NavLink to="/fichiers-catalogues-clients" activeClassName="active">
              <FontAwesomeIcon icon={faFilePdf} />
              <span>Admin Catalogues Clients</span>
            </NavLink>
          </>
        )}
        <NavLink to="/liste-produits" activeClassName="active">
          <FontAwesomeIcon icon={faClipboardList} />
          <span>Liste produits / stocks</span>
        </NavLink>
            <NavLink to="/liste-catalogues" activeClassName="active">
              <FontAwesomeIcon icon={faClipboardList} />
              <span>Liste Catalogues</span>
            </NavLink>
        <button className="button_logout" onClick={handleLogOut}>
          <FontAwesomeIcon icon={faSignOutAlt} />
          <span>Deconnexion</span>
        </button>
        <button className="button-handleclick" onClick={handleClick}>
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
    </>
  );
};

export default Nav;
